import styled, { css } from 'styled-components';
import { getFontStyle } from '../../utils';
export const StyledText = styled.span `
  ${({ theme, color, size, maxWidth, truncate, fontWeight, fontStyle, block, }) => css `
    display: ${block ? 'block' : 'inline'};
    ${getFontStyle(size)}
    color: ${color !== null && color !== void 0 ? color : theme.Color.Neutrals.Dark};
    ${maxWidth && `max-width: ${maxWidth}px;`}
    ${fontWeight && `font-weight: ${fontWeight};`}
    ${fontStyle && `font-style: ${fontStyle};`}
    ${truncate &&
    `
          text-wrap: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        `}
  `}

  font-family: ${({ theme, fontFamily }) => fontFamily !== null && fontFamily !== void 0 ? fontFamily : theme.Typography.FontFamily};
`;
//# sourceMappingURL=Text.style.js.map